// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import Modal from "../organisms/Modal";
import { getEventDateString } from "../../utils/date";
import Image from "../atoms/Image";
import Pill from "../atoms/Pill";
import { getDateString } from "../../utils/date";
import { ReactComponent as DotsLoader } from "../../../assets/images/dots-loader.svg";

type PropsType = {
    data: any,
    active: boolean,
    onClose: Function,
};

const TicketDetailModal = (props: PropsType): React.Node => {
    const { profile } = useSelector((state: any): any => state.user);

    return (
        <Modal
            aside={true}
            active={props.active}
            className="ticket-detail-modal"
            onClose={props.onClose}
            onOverlayClick={props.onClose}
        >
            <Modal.Header>View ticket</Modal.Header>
            <Modal.Content>
                <div
                    className={`container-fluid ticket-detail-modal__loading-copy ${
                        props.data?.status
                            ? props.data?.status === "completed" ||
                              props.data?.events.length === 0
                                ? "ticket-detail-modal__loading-copy--invisible"
                                : ""
                            : "ticket-detail-modal__loading-copy--unused"
                    }`}
                >
                    Can’t see your ticket? Give us 2-3 mins to create it.
                </div>
                {props.data?.events.length > 0 ? (
                    props.data?.events.map(event => {
                        const dateFormat =
                            event.startDate?.slice(-2) === "am" ||
                            event.startDate?.slice(-2) === "pm"
                                ? "dd/MM/yyyy h:mm aaa"
                                : "yyyy-MM-dd HH:mm:ss";
                        return (
                            <div
                                key={event.eventId}
                                className="container-fluid ticket-detail-modal__content__inner"
                            >
                                {event.startDate && event.endDate ? (
                                    <Pill
                                        color="green"
                                        className="ticket-detail-modal__badge"
                                    >
                                        {getDateString(
                                            event.startDate,
                                            true,
                                            dateFormat
                                        ) ===
                                        getDateString(
                                            event.endDate,
                                            true,
                                            dateFormat
                                        )
                                            ? getDateString(
                                                  event.startDate,
                                                  true,
                                                  dateFormat
                                              )
                                            : `${getDateString(
                                                  event.startDate,
                                                  true,
                                                  dateFormat
                                              )} - ${getDateString(
                                                  event.endDate,
                                                  true,
                                                  dateFormat
                                              )}`}
                                    </Pill>
                                ) : null}
                                {event.eventName ? (
                                    <h3 className="ticket-detail-modal__event-title">
                                        {event.eventName}
                                    </h3>
                                ) : null}
                                {event.startDate &&
                                event.endDate &&
                                event.location ? (
                                    <div className="ticket-detail-modal__event-description">
                                        <div>
                                            <div className="ticket-detail-modal__event-description__label">
                                                When
                                            </div>
                                            <div className="ticket-detail-modal__event-description__info">
                                                {getEventDateString(
                                                    event.startDate,
                                                    event.endDate,
                                                    dateFormat
                                                ).map(date => (
                                                    <div key={date}>{date}</div>
                                                ))}
                                            </div>
                                        </div>

                                        <div>
                                            <>
                                                <div className="ticket-detail-modal__event-description__label">
                                                    Where
                                                </div>
                                                <div className="ticket-detail-modal__event-description__info">
                                                    {event.location}
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                ) : null}
                                {event.tickets
                                    ? event.tickets.map((ticket, key) => {
                                          return (
                                              <div
                                                  key={key}
                                                  className="ticket-detail-modal__ticket"
                                              >
                                                  <div className="ticket-detail-modal__ticket__count">{`${
                                                      key + 1
                                                  }/${
                                                      event.tickets.length
                                                  }`}</div>
                                                  <div className="ticket-detail-modal__ticket__label">
                                                      {ticket.type
                                                          ? `${
                                                                ticket.type ===
                                                                "Team"
                                                                    ? "Team"
                                                                    : ""
                                                            } Ticket`
                                                          : null}
                                                  </div>
                                                  {ticket.firstName &&
                                                  ticket.lastName &&
                                                  ticket.email ? (
                                                      <>
                                                          <div className="ticket-detail-modal__ticket__name">
                                                              {`${ticket.firstName} ${ticket.lastName}`}
                                                          </div>

                                                          <div className="ticket-detail-modal__ticket__email">
                                                              {ticket.email}
                                                          </div>
                                                      </>
                                                  ) : profile.first_name &&
                                                    profile.last_name &&
                                                    profile.email ? (
                                                      <>
                                                          <div className="ticket-detail-modal__ticket__name">
                                                              {`${profile.first_name} ${profile.last_name}`}
                                                          </div>
                                                          <div className="ticket-detail-modal__ticket__email">
                                                              {profile.email}
                                                          </div>
                                                      </>
                                                  ) : null}
                                                  <div className="ticket-detail-modal__ticket__qr">
                                                      <Image
                                                          src={ticket.qrcodeUrl}
                                                          aspectRatio="1:1"
                                                          alt="QR"
                                                      />
                                                  </div>
                                              </div>
                                          );
                                      })
                                    : null}
                            </div>
                        );
                    })
                ) : (
                    <div className="ticket-detail-modal__loader">
                        <DotsLoader className="loader__cover__loader loader" />
                    </div>
                )}
            </Modal.Content>
        </Modal>
    );
};

export default TicketDetailModal;
